var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboards(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 384,
    height: 384,
    viewBox: "0 0 384 384",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M174 147L30 219V147L174 75V147Z",
    fill: "#0A3759",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M74 154L50 166L50 142L74 130V154Z",
    fill: "#66BB6A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M102 140L78 152L78 128L102 116V140Z",
    fill: "#FFC107"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M130 126L106 138L106 114L130 102V126Z",
    fill: "#FF5722"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M158 112L134 124L134 100L158 88V112Z",
    fill: "#22AAFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M74 182L50 194L50 170L74 158V182Z",
    fill: "#66BB6A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74 196L50 208L50 197L74 185V196Z",
    fill: "white",
    fillOpacity: 0.16
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102 182L78 194L78 183L102 171V182Z",
    fill: "white",
    fillOpacity: 0.16
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M130 168L106 180L106 169L130 157V168Z",
    fill: "white",
    fillOpacity: 0.16
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M158 154L134 166L134 155L158 143V154Z",
    fill: "white",
    fillOpacity: 0.16
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M102 168L78 180L78 156L102 144V168Z",
    fill: "#22AAFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M80 179L78 180L78 172L80 171V179Z",
    fill: "#22AAFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M84 177L82 178L82 174L84 173V177Z",
    fill: "#22AAFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M88 175L86 176L86 168L88 167V175Z",
    fill: "#22AAFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M92 173L90 174L90 164L92 163V173Z",
    fill: "#22AAFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M96 171L94 172L94 160L96 159V171Z",
    fill: "#22AAFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M100 169L98 170L98 160L100 159V169Z",
    fill: "#22AAFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M158 140L106 166L106 142L158 116V140Z",
    fill: "white",
    fillOpacity: 0.16
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5822 150.356V147.641C65.5822 146.908 65.5056 146.302 65.3524 145.822C65.1993 145.338 64.9811 144.978 64.698 144.741C64.4102 144.512 64.0621 144.405 63.6536 144.419C63.2451 144.433 62.7856 144.569 62.275 144.827C61.7691 145.083 61.3118 145.41 60.9034 145.809C60.4996 146.206 60.1561 146.663 59.8729 147.181C59.5851 147.706 59.3647 148.288 59.2115 148.927C59.0583 149.561 58.9817 150.245 58.9817 150.978V153.694C58.9817 154.427 59.0583 155.036 59.2115 155.52C59.3693 155.997 59.5921 156.35 59.8799 156.579C60.163 156.815 60.5088 156.926 60.9173 156.912C61.3258 156.898 61.783 156.763 62.2889 156.507C62.7995 156.249 63.259 155.921 63.6675 155.522C64.076 155.123 64.4218 154.662 64.7049 154.139C64.9881 153.621 65.2039 153.047 65.3524 152.415C65.5056 151.776 65.5822 151.09 65.5822 150.356ZM60.9312 151.772C60.9312 151.61 60.9312 151.488 60.9312 151.405C60.9312 151.322 60.9312 151.155 60.9312 150.906V149.649C60.9312 149.228 60.9591 148.85 61.0148 148.515C61.0751 148.178 61.1656 147.882 61.2863 147.629C61.3977 147.39 61.5347 147.186 61.6971 147.015C61.8642 146.837 62.0568 146.693 62.275 146.583C62.47 146.484 62.644 146.432 62.7972 146.428C62.955 146.416 63.0873 146.455 63.1941 146.547C63.3333 146.659 63.4377 146.85 63.5074 147.122C63.5816 147.386 63.6234 147.729 63.6327 148.151L60.9312 151.772ZM63.6327 151.67C63.6327 152.091 63.6025 152.473 63.5422 152.815C63.4865 153.151 63.4006 153.446 63.2846 153.703C63.1732 153.946 63.0339 154.157 62.8668 154.335C62.6997 154.508 62.5071 154.65 62.2889 154.76C62.0522 154.88 61.848 154.931 61.6762 154.914C61.5045 154.896 61.3629 154.809 61.2515 154.652C61.154 154.525 61.0774 154.343 61.0217 154.105C60.9707 153.866 60.9405 153.577 60.9312 153.238L63.6327 149.626C63.6327 149.776 63.6327 149.893 63.6327 149.977C63.6327 150.055 63.6327 150.179 63.6327 150.351V151.67Z",
    fill: "#66BB6A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3455 132.458C93.3455 131.943 93.2643 131.532 93.1018 131.224C92.944 130.908 92.7235 130.687 92.4404 130.559C92.1526 130.434 91.8137 130.403 91.4238 130.465C91.0339 130.522 90.6092 130.666 90.1497 130.898C89.6901 131.131 89.2654 131.416 88.8755 131.753C88.4903 132.083 88.1584 132.454 87.8799 132.865C87.5967 133.279 87.3763 133.723 87.2184 134.198C87.0606 134.668 86.9817 135.161 86.9817 135.676C86.9817 135.956 87.0142 136.208 87.0792 136.43C87.1488 136.65 87.2463 136.834 87.3716 136.984C87.4877 137.128 87.6292 137.241 87.7963 137.323C87.9681 137.403 88.1584 137.45 88.3673 137.464C88.1213 137.718 87.8985 137.99 87.6989 138.278C87.5039 138.558 87.3368 138.848 87.1976 139.148C87.0583 139.452 86.9492 139.765 86.8703 140.085C86.7961 140.399 86.7589 140.711 86.7589 141.023C86.7589 141.559 86.8448 141.986 87.0165 142.305C87.1929 142.622 87.4343 142.838 87.7406 142.953C88.047 143.074 88.4067 143.1 88.8198 143.032C89.2376 142.961 89.6878 142.804 90.1706 142.56C90.6487 142.318 91.0943 142.022 91.5074 141.673C91.9205 141.324 92.2802 140.934 92.5866 140.503C92.8883 140.08 93.125 139.622 93.2967 139.13C93.4731 138.635 93.5613 138.12 93.5613 137.584C93.5613 137.178 93.4987 136.835 93.3733 136.555C93.248 136.276 93.0739 136.062 92.8511 135.914C92.7305 135.83 92.5935 135.769 92.4404 135.732C92.2872 135.69 92.1247 135.665 91.953 135.659C92.1433 135.453 92.315 135.239 92.4682 135.016C92.626 134.785 92.763 134.555 92.879 134.324C93.0275 134.02 93.1412 133.713 93.2202 133.403C93.3037 133.085 93.3455 132.77 93.3455 132.458ZM91.6188 138.418C91.6188 138.678 91.5816 138.931 91.5074 139.176C91.4377 139.414 91.3403 139.638 91.2149 139.847C91.085 140.058 90.9318 140.248 90.7554 140.415C90.579 140.577 90.3841 140.712 90.1706 140.82C89.9524 140.93 89.7551 140.996 89.5787 141.018C89.4024 141.034 89.2515 141.006 89.1262 140.934C88.9916 140.862 88.8871 140.738 88.8129 140.562C88.7386 140.386 88.7015 140.163 88.7015 139.893C88.7015 139.633 88.7363 139.381 88.8059 139.138C88.8755 138.895 88.973 138.666 89.0983 138.452C89.2237 138.243 89.3745 138.055 89.5509 137.887C89.7319 137.718 89.9338 137.577 90.1566 137.464C90.3794 137.351 90.579 137.29 90.7554 137.278C90.9364 137.265 91.0919 137.298 91.2219 137.378C91.3472 137.465 91.4447 137.596 91.5143 137.768C91.584 137.941 91.6188 138.158 91.6188 138.418ZM91.4169 133.535C91.4169 133.763 91.3867 133.989 91.3263 134.212C91.2706 134.428 91.1894 134.63 91.0827 134.819C90.9759 135.008 90.8459 135.181 90.6928 135.336C90.5396 135.486 90.3655 135.611 90.1706 135.709C89.9756 135.808 89.7992 135.861 89.6414 135.868C89.4882 135.867 89.3583 135.826 89.2515 135.745C89.1401 135.666 89.0566 135.547 89.0009 135.388C88.9452 135.224 88.9173 135.027 88.9173 134.798C88.9173 134.564 88.9428 134.341 88.9939 134.128C89.0496 133.907 89.1308 133.705 89.2376 133.521C89.3397 133.339 89.4673 133.176 89.6205 133.031C89.7737 132.88 89.9478 132.756 90.1427 132.657C90.3423 132.556 90.5187 132.504 90.6719 132.499C90.8297 132.492 90.9643 132.525 91.0757 132.599C91.1825 132.68 91.266 132.799 91.3263 132.956C91.3867 133.113 91.4169 133.306 91.4169 133.535Z",
    fill: "#FFC107"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M115.083 129.949V118.589L114.979 118.642L110.565 122.66V124.548L113.127 122.223V130.938L115.083 129.949ZM120.855 120.398V122.084L121.907 121.552C122.171 121.418 122.408 121.332 122.617 121.294C122.83 121.254 123.014 121.265 123.167 121.328C123.315 121.394 123.429 121.516 123.508 121.694C123.587 121.873 123.626 122.116 123.626 122.422C123.626 122.667 123.592 122.906 123.522 123.138C123.457 123.369 123.36 123.585 123.23 123.786C123.095 124.004 122.928 124.203 122.728 124.382C122.529 124.561 122.304 124.714 122.053 124.841C121.83 124.953 121.626 125.02 121.44 125.041C121.255 125.057 121.094 125.032 120.96 124.964C120.821 124.905 120.714 124.803 120.64 124.658C120.565 124.509 120.528 124.324 120.528 124.106L118.593 125.085C118.593 125.636 118.688 126.066 118.878 126.376C119.073 126.683 119.331 126.888 119.651 126.992C119.971 127.1 120.335 127.119 120.744 127.047C121.157 126.969 121.579 126.82 122.011 126.602C122.512 126.348 122.979 126.04 123.411 125.676C123.847 125.304 124.223 124.896 124.539 124.45C124.854 124.01 125.103 123.536 125.284 123.028C125.465 122.52 125.555 122.001 125.555 121.471C125.555 121.169 125.523 120.899 125.458 120.662C125.393 120.424 125.293 120.225 125.158 120.064C125.024 119.909 124.852 119.795 124.643 119.724C124.439 119.65 124.195 119.628 123.912 119.657C124.153 119.405 124.367 119.143 124.552 118.872C124.738 118.597 124.894 118.32 125.019 118.044C125.144 117.767 125.239 117.495 125.304 117.228C125.369 116.956 125.402 116.698 125.402 116.453C125.402 115.923 125.318 115.5 125.151 115.184C124.989 114.86 124.759 114.636 124.462 114.51C124.165 114.39 123.807 114.368 123.39 114.444C122.972 114.514 122.512 114.677 122.011 114.93C121.547 115.165 121.113 115.46 120.709 115.815C120.31 116.167 119.962 116.554 119.665 116.975C119.368 117.401 119.133 117.847 118.962 118.313C118.794 118.777 118.711 119.241 118.711 119.704L120.646 118.725C120.646 118.517 120.684 118.311 120.758 118.107C120.832 117.903 120.934 117.709 121.064 117.523C121.19 117.345 121.336 117.183 121.503 117.036C121.675 116.887 121.858 116.763 122.053 116.664C122.29 116.545 122.496 116.477 122.673 116.46C122.854 116.442 123.002 116.468 123.118 116.539C123.234 116.616 123.32 116.734 123.376 116.893C123.436 117.044 123.466 117.232 123.466 117.456C123.466 117.684 123.436 117.913 123.376 118.141C123.32 118.362 123.234 118.569 123.118 118.763C122.993 118.982 122.828 119.188 122.624 119.379C122.424 119.564 122.185 119.726 121.907 119.867L120.855 120.398Z",
    fill: "#FF5722"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M142.721 110.538L144.267 110.185C144.341 110.064 144.42 109.946 144.504 109.831C144.587 109.711 144.682 109.595 144.789 109.484C144.896 109.373 145.019 109.264 145.158 109.157C145.297 109.05 145.462 108.949 145.652 108.853C145.936 108.71 146.182 108.635 146.39 108.628C146.599 108.621 146.773 108.673 146.913 108.785C147.052 108.897 147.154 109.063 147.219 109.285C147.289 109.5 147.323 109.758 147.323 110.06C147.323 110.367 147.296 110.667 147.24 110.96C147.189 111.251 147.108 111.521 146.996 111.77C146.88 112.021 146.729 112.248 146.544 112.451C146.363 112.652 146.142 112.818 145.882 112.95C145.46 113.163 145.112 113.204 144.838 113.072C144.569 112.938 144.411 112.635 144.364 112.164L142.457 113.129C142.471 113.647 142.575 114.063 142.77 114.375C142.97 114.68 143.227 114.893 143.543 115.014C143.858 115.135 144.218 115.167 144.622 115.108C145.03 115.047 145.453 114.906 145.889 114.686C146.465 114.395 146.964 114.041 147.386 113.625C147.809 113.208 148.159 112.755 148.437 112.266C148.716 111.777 148.923 111.269 149.057 110.743C149.192 110.218 149.259 109.7 149.259 109.19C149.259 108.592 149.189 108.092 149.05 107.689C148.911 107.286 148.711 106.986 148.451 106.79C148.187 106.596 147.862 106.511 147.477 106.534C147.096 106.549 146.662 106.68 146.175 106.927C145.831 107.101 145.527 107.304 145.263 107.536C144.998 107.769 144.794 107.968 144.65 108.135L144.894 105.515L148.925 103.477V101.635L143.299 104.48L142.721 110.538Z",
    fill: "#22AAFF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M106 154L120 147",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M124 145L130 142",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M106 158L120 151",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M124 149L130 146",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M106 162L120 155",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M124 153L130 150",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M134 140L144 135",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M148 133L158 128",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M134 144L144 139",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M148 137L158 132",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M134 148L144 143",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M148 141L158 136",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M78 160L86 156",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M106 146L118 140",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M50 201L54 199",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M58 197L62 195",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M90 154L94 152",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M66 138L58 142",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M54 144L50 146",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M106 173L110 171",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M114 169L118 167",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M122 138L126 136",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M78 187L86 183",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M134 159L142 155",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M78 132L82 130",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M106 118L110 116",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M134 104L138 102",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M62 170.482C58.886 171.94 56 176.482 56 181.014C56 181.901 56.1374 182.666 56.3761 183.311L62 178V170.482Z",
    fill: "#66BB6A"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.84,
    d: "M65.7552 182.068C64.1872 184.402 62.0209 186 59.9998 186C58.524 186 57.0482 185.128 56.376 183.311L61.9998 178L65.7552 182.068Z",
    fill: "#66BB6A"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M67.7465 173.074L62 178L65.7553 182.068C67.0966 180.072 68 177.536 68 175C68 174.278 67.909 173.637 67.7465 173.074Z",
    fill: "#66BB6A"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M67.7465 173.074L62 178V170.482C62.6649 170.171 63.3402 170 64 170C65.5735 170 67.147 171 67.7465 173.074Z",
    fill: "#66BB6A"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M50 174L54 172",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M58 170L62 168",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M66 166L70 164",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M24 144L30 147V219L24 216V144Z",
    fill: "#0F5D99",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M168 72L174 75L30 147L24 144L168 72Z",
    fill: "#147CCC",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M44 140L92 116L140 164L92 188L44 140Z",
    fill: "white",
    fillOpacity: 0.08
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M96 114L112 106L160 154L144 162L96 114Z",
    fill: "white",
    fillOpacity: 0.08
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M360 240L216 312V240L360 168V240Z",
    fill: "#0A3759",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M316 247L236 287L236 235L316 195V247Z",
    fill: "#22AAFF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M344 233L320 245L320 193L344 181V233Z",
    fill: "#22AAFF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M344 247L320 259L320 248L344 236V247Z",
    fill: "#64C8FF"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M320 197L324 195",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M328 193L332 191",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M293 228L296 224L295 223L298 218L303 210L306 208L310 205L313 200L316 199V247L292 259L294 255L292 253V249H290V247L291 246L290 241L292 239L291 237L289 236L290 232L292 231L293 228Z",
    fill: "#22AAFF"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M272 217L304 201L299 206L294 210H292L289 213H288L281 219L278 221V219L274 220L272 217Z",
    fill: "#22AAFF"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M236 235L266 220L269 230L265 233L264 230L261 231V236L258 237L255 242L256 253L259 251L260 252L257 255L258 263L248 281L236 287V235Z",
    fill: "#22AAFF"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M236 239L244 235",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M248 233L256 229",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M275 239L277 237L279 239V247H275V239Z",
    fill: "#22AAFF"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M210 237L216 240V312L210 309V237Z",
    fill: "#0F5D99",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M354 165L360 168L216 240L210 237L354 165Z",
    fill: "#147CCC",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M260 289L236 301L236 290L260 278V289Z",
    fill: "#64C8FF"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M288 275L264 287L264 276L288 264V275Z",
    fill: "#64C8FF"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M320 237L334 230",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M320 233L326 230",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M334 218L340 215",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M334 210L336 209",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M320 209L324 207",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M330 228L336 225",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M320 241L330 236",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M320 221L338 212",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M320 205L342 194",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M320 217L330 212",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M320 225L330 220",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M320 229L330 224",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M328 205L338 200",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M320 213L326 210",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M316 261L292 273L292 262L316 250V261Z",
    fill: "#64C8FF"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M230 233L278 209L326 257L278 281L230 233Z",
    fill: "white",
    fillOpacity: 0.08
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M282 207L298 199L346 247L330 255L282 207Z",
    fill: "white",
    fillOpacity: 0.08
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M336 244L332 246",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M328 248L320 252",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M252 286L244 290",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M240 292L236 294",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M292 266L300 262",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M304 260L308 258",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M279 263L282 261L284 262L285 262.5L270 270L274 266L277 265L276 262L278 261L279 263Z",
    fill: "#22AAFF"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M264 280L268 278",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M272 276L276 274",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M280 272L284 270",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M267 194L123 266V194L267 122V194Z",
    fill: "#0A3759",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M167 201L143 213L143 189L167 177V201Z",
    fill: "#FF5722"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M167 229L143 241L143 217L167 205V229Z",
    fill: "#66BB6A"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M167 243L143 255L143 245L167 233V243Z",
    fill: "#FFC107"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M251 159L171 199L171 175L251 135V159Z",
    fill: "#FF5722"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M251 159L171 199V196L179 190H187L195 180H203L211 170L219 172L227 154L235 156L243 146L251 148V159Z",
    fill: "#FF5722"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M251 187L171 227L171 203L251 163V187Z",
    fill: "#66BB6A"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M251 201L171 241L171 231L251 191V201Z",
    fill: "#FFC107"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M143 193L151 189",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M143 209L147 207",
    stroke: "#FF5722",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M143 205L147 203",
    stroke: "#FF5722",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M151 205L157 202",
    stroke: "#FF5722",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M161 200L167 197",
    stroke: "#FF5722",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M143 201L147 199",
    stroke: "#FF5722",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M151 201L157 198",
    stroke: "#FF5722",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M161 196L167 193",
    stroke: "#FF5722",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M143 229L153 224",
    stroke: "#66BB6A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M157 222L167 217",
    stroke: "#66BB6A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M157 226L167 221",
    stroke: "#66BB6A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M143 233L153 228",
    stroke: "#66BB6A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M157 230L167 225",
    stroke: "#66BB6A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M143 237L153 232",
    stroke: "#66BB6A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M151 197L157 194",
    stroke: "#FF5722",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M161 192L167 189",
    stroke: "#FF5722",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M195 195L187 199",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M171 179L179 175",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M187 227L179 231",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M143 221L151 217",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M143 249L151 245",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M183 201L179 203",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M183 173L187 171",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M175 205L171 207",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M191 169L195 167",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M195 223L191 225",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M175 233L171 235",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M251 187L171 227V224L179 220L187 214L195 206L203 194L211 187L219 186L227 190H235L243 188L251 184V187Z",
    fill: "#66BB6A"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M117 191L123 194V266L117 263V191Z",
    fill: "#0F5D99",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M261 119L267 122L123 194L117 191L261 119Z",
    fill: "#147CCC",
    stroke: "#64C8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M137 187L185 163L233 211L185 235L137 187Z",
    fill: "white",
    fillOpacity: 0.08
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M189 161L205 153L253 201L237 209L189 161Z",
    fill: "white",
    fillOpacity: 0.08
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboards);
export default __webpack_public_path__ + "static/media/dashboards.3d80b73ff570586e552477b3971d436e.svg";
export { ForwardRef as ReactComponent };